<template>
    <div class="relative bg-gradient-to-r text-white py-5 z-10 title-banner"
    >
      <div class="container mx-auto justify-self-start">
        <h1 class="text-lg px-10 font-medium">{{title}}</h1>
      </div>
    </div>
  </template>
  
  <style scoped>
  div {
    font-family: 'Tajawal', sans-serif;
  }
  .title-banner {
    padding: 16px 0;
    background-color: #163151;
    background: url(../../assets/pic/title-banner-bg.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin-bottom: 15px;
  }
  </style>
<script>
export default {
  props:{
    title:String
  }
}
</script>